module.exports = __webpack_public_path__ + "static/img/zhubo1.85be7824.jpg";